import React from 'react';

interface Props {
  className?: string;
  height?: number;
  width?: number;
  color?: string;
}

export const ChevronRight = ({
  className = '',
  height = 24,
  width = 24,
  color = 'currentColor',
}: Props) => (
  <svg
    data-testid="chevron-right-icon"
    className={className}
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.993 13.4269L10.7192 17.7047C10.3253 18.0984 9.68777 18.0984 9.29389 17.7047C8.90204 17.3098 8.90204 16.6708 9.29389 16.278L13.5687 12.0003L9.29389 7.72348C8.90204 7.32765 8.90204 6.68965 9.29389 6.29687C9.68675 5.90104 10.3243 5.90104 10.7192 6.29687L14.993 10.5747L15.7046 11.287C16.0985 11.6818 16.0985 12.3198 15.7046 12.7136L14.993 13.4269Z"
      fill={color}
    />
  </svg>
);
